(function () {

  // ── Übersetzungen ──────────────────────────────────────────────
  const i18n = {
    de: {
      label:  'Produkt-Empfehlung',
      cta:    'Jetzt ansehen',
      locale: 'de-DE',
    },
    en: {
      label:  'Product Recommendation',
      cta:    'View Product',
      locale: 'en-GB',
    },
  };

  // Shopify setzt window.Shopify.locale auf den aktiven Sprachcode ('de' / 'en')
  const lang   = (window.Shopify?.locale || 'de').split('-')[0];
  const t      = i18n[lang] ?? i18n.de;
  const currency = window.Shopify?.currency?.active || 'EUR';

  // ── Hilfsfunktionen ───────────────────────────────────────────
  const formatMoney = (cents) =>
    new Intl.NumberFormat(t.locale, { style: 'currency', currency }).format(cents / 100);

  // ── Rendering ─────────────────────────────────────────────────
  async function renderTeasers() {
    const elements = document.querySelectorAll('[data-product-teaser]');
    if (!elements.length) return;

    for (const el of elements) {
      const handle = el.dataset.productTeaser;
      if (!handle) continue;

      el.innerHTML = '<div class="ipt-skeleton"></div>';
      el.classList.add('ipt-wrapper');

      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error('Not found');
        const p = await res.json();

        const image = p.featured_image
          ? `<img class="ipt-image" src="${p.featured_image}" alt="${p.title}" loading="lazy">`
          : '';

        el.innerHTML = `
          <a href="/products/${handle}" class="ipt-card">
            ${image}
            <div class="ipt-body">
              <span class="ipt-label">${t.label}</span>
              <span class="ipt-title">${p.title}</span>
              <span class="ipt-price">${formatMoney(p.price)}</span>
              <span class="ipt-btn">${t.cta}</span>
            </div>
          </a>
        `;
      } catch (e) {
        el.innerHTML = '';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', renderTeasers);
})();